import React, { useEffect, useState } from 'react';
import { getAgreementTemplates } from '../../../api/getAgreementTemplates';
import Loading from '../../../common/components/Loading';
import Icon from '../../../common/components/Icon';
import { t } from 'i18next';

function ContractTemplates({ setActiveTab }) {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchTemplates() {
            try {
                setLoading(true);
                const fetchedTemplates = await getAgreementTemplates();
                setTemplates(fetchedTemplates.items);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }
        fetchTemplates();
    }, []);

    if (loading) return <Loading />;
    if (error) return <div className="w-full text-red-500 text-sm p-4">{error}</div>;

    return (
        <div className="w-full">
            <Icon src="backicon" onClick={() => setActiveTab(null)} className="block md:hidden fixed left-5 top-[23px] cursor-pointer z-[102]" />

            <div className="bg-white rounded-2xl p-6">
                {templates.length === 0 ? (
                    <p className="text-gray-400 text-sm text-center py-8">{t('no_nothing')}</p>
                ) : (
                    <ul className="flex flex-col gap-3">
                        {templates.map((template, index) => (
                            <li key={template.id || index}
                                className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors"
                            >
                                <div className="flex items-center gap-3 min-w-0">
                                    <div className="w-10 h-10 bg-[#147F26]/10 rounded-full flex items-center justify-center flex-shrink-0">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#147F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M15.75 9H8.25" stroke="#147F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M15.75 13H8.25" stroke="#147F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M11.75 17H8.25" stroke="#147F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-sm font-semibold text-gray-800 truncate">{template.name}</p>
                                        <p className="text-xs text-gray-400 mt-0.5">
                                            {new Date(template.created_at).toLocaleDateString()}
                                        </p>
                                    </div>
                                </div>

                                <a
                                    href={template.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex-shrink-0 ml-3 px-4 py-2 bg-[#147F26] hover:bg-[#0f5f1a] text-white text-xs font-semibold rounded-xl transition-colors"
                                >
                                    {t('open') || 'Ашу'}
                                </a>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default ContractTemplates;
